export default {
  Subs: {
    perMonth: "/ mois par utilisateur",
    perYear: "/ an par utilisateur",
    perQuarter: "/ trimestre par utilisateur",
    For: "Abonnement pour",
    for: "S'abonner à",
    PTM: `La plateforme pour les médecins «Third Opinion»`,
    forAI: "pour accéder à l'assistant IA",
    subDescription:
      "Un assistant intelligent qui peut répondre aux questions d'une vaste bibliothèque médicale. Grâce à un apprentissage en profondeur basé sur des données à jour en médecine, biologie et sciences connexes, le chatbot offre des réponses précises et vérifiées basées sur des faits clés et des recherches scientifiques tirées de cette série de livres.",
    BySub: "Par abonnement",
    Free: "Gratuit",
    CostDesc: "à <period> par utilisateur",
    month: "mois",
    day: "jour",
    year: "année",
    Connect: "Connecter",
    Connectv2: "Abonnement Connect",
    CorpPlan: {
      desc: "Individuel",
      feature_1: "Programmes individuels",
      feature_2:
        "Traitement d'un nombre sélectionné d'études par mois à l'aide de n'importe quelle IA",
      cost: "Sur demande",
      request: "Soumettre une demande",
      requested: "Votre demande a été soumise avec succès !",
      requested2:
        "Nous vous contacterons prochainement pour discuter de tous les détails et vous proposer une solution adaptée. Pour toute question, <a target='_blank' class='demo__underline' href='https://t.me/thirdopinion_support_bot'>écrivez-nous !</a>",
    },
    yourSub: "Déjà abonné",
    PlansDesc: "Description détaillée des tarifs",
    Offer: "Offre",
    EnterPromo: "Entrez le code promotionnel",
    promoNotFound: "Ce code promo n'existe pas",
    promoNotActive: "Le code promo est inactif",
    Errors: {
      NotPurchase:
        "Échec de la connexion de l'abonnement, veuillez réessayer plus tard",
    },
    DiffSubs: "Différences entre les tarifs",
    Plan: "Tarif",
    Unavailable: "Vous devez d'abord vous désabonner",
    extSub: "Sélectionner l'abonnement étendu",
    lets: {
      modalTitle: {
        base: "Entrez votre",
        and: " et ",
        phone: " numéro de téléphone",
        email: " e-mail",
      },
      text: "Pour finaliser votre abonnement, veuillez saisir votre <PHONE><EMAIL>. Cela nous permettra de vous envoyer des notifications sur l'état de votre abonnement, les confirmations de transaction et d'autres messages importants.",
      formInvalid: "Le formulaire est mal rempli",
    },
    cancelSub: "Annuler",
    unsub: {
      title: "Vous n'aurez plus accès à :",
      modalTitle: "Êtes-vous sûr de vouloir annuler votre abonnement ?",
      modalTitle2: "Sélectionnez la raison de l'annulation",
      cancel:
        "L'abonnement <NAME> a été renouvelé. Le prochain prélèvement aura lieu le <DATE>.",
      yes: "Annuler l'abonnement",
      no: "Conserver l'abonnement",
      thx: {
        title: "Merci d'avoir séjourné avec nous !",
        continue: "Continuer",
      },
      reasons: {
        0: "Le prix n'est pas adapté",
        1: "Je n'utilise pas le service",
        2: "Interface peu pratique",
        3: "Autre",
      },
      complete: {
        title: "Vous avez annulé votre abonnement",
        text1: "Votre abonnement restera actif jusqu'au ",
        text2:
          ", vous pouvez continuer à utiliser l'abonnement jusqu'à cette date. \nNous serons heureux de vous revoir !",
        recover: "Réactiver l'abonnement",
      },
    },
    backToSite: "Retour au site",
    afterPay: {
      title: "Votre abonnement a été activé avec succès !",
      text: "Vous avez désormais accès aux fonctionnalités étendues du service !",
      buttonText: "Commencer",
    },
  },
};
